const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";

const routes = [
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor",
    name: "cadastro-de-habilitacao-do-servidor",
    meta: {
      allowedPermissions: ["habilitacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/novo/:servidorId",
    name: "cadastro-de-habilitacao-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilitacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/editar/:id",
    name: "cadastro-de-habilitacao-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilitacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/visualizar/:id",
    name: "cadastro-de-habilitacao-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilitacao_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorShow.vue"
      ),
  },
];

export default routes;
